import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/honor-mini-logo.png'
import _imports_1 from '../assets/kfEwm.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-7b9e5f26")

_pushScopeId("data-v-7b9e5f26")
const _hoisted_1 = { class: "navbar navbar-dark bg-primary justify-content-between mb-2 px-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  alt: "华耐 LOGO",
  width: "30",
  height: "24",
  class: "d-inline-block align-text-top",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 华耐设计云 ")
const _hoisted_4 = {
  key: 0,
  class: "list-inline mb-0"
}
const _hoisted_5 = { class: "list-inline-item" }
const _hoisted_6 = { class: "list-inline-item" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "kf-pop-box" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createTextVNode(" 微信/企业微信 扫码咨询 ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "navbar-brand",
      to: "/home"
    }, {
      default: _withId(() => [
        _hoisted_2,
        _hoisted_3
      ]),
      _: 1
    }),
    (_ctx.user.isLogin)
      ? (_openBlock(), _createBlock("ul", _hoisted_4, [
          _createVNode("li", _hoisted_5, [
            _createVNode("a", {
              href: "#",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showKf && _ctx.showKf(...args)), ["prevent"])),
              class: "btn btn-outline-light my-2"
            }, "联系客服")
          ]),
          _createVNode("li", _hoisted_6, [
            _createVNode("a", {
              href: "#",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
              class: "btn btn-outline-light my-2"
            }, "退出登陆")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowKf)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "kf-pop",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hideKf && _ctx.hideKf(...args)), ["prevent"]))
        }, [
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ]))
})